import Vue from 'vue'
import Router from 'vue-router'

// import view
import Home from '@/components/views/Home'
import About from '@/components/views/About'
import Maps from '@/components/views/Maps'
import Chartist from '@/components/views/Chartist.vue'
import Chart from '@/components/views/Chart.vue'
import Grids from '@/components/views/Grids.vue'
import OwlSlider from '@/components/views/Crousel.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/chartist',
      name: 'chartist-section',
      component: Chartist
    },
    {
      path: '/charts',
      name: 'single-chart',
      component: Chart
    },
    {
      path: '/grids',
      name: 'grids',
      component: Grids
    },
    {
      path: '/carousel',
      name: 'mySlider',
      component: OwlSlider
    },
    {
      path: '/maps',
      view: 'Maps',
      component: Maps
    }
  ]
})
